import { SET_NOTIFY_GEN_AI_ROOM_READY, 
    SET_GEN_AI_ROOM_READY_NOTIFICATION
 } from "../actions/dsr-gen-ai-actions-types";


const INITIAL_STATE_SET_GEN_AI_ROOM_READY = { results: '' }

export function setNotifyGenAiRoomReadyReducer(state = INITIAL_STATE_SET_GEN_AI_ROOM_READY, action) {
    switch (action.type) {
        case SET_NOTIFY_GEN_AI_ROOM_READY:
            return { results: action.payload }
        default:
            return state;
    }
}


const INITIAL_STATE_SET_GEN_AI_ROOM_READY_NOTIFICATION = { results: '' }

export function setGenAiRoomReadyNotitificationReducer(state = INITIAL_STATE_SET_GEN_AI_ROOM_READY_NOTIFICATION, action) {
    switch (action.type) {
        case SET_GEN_AI_ROOM_READY_NOTIFICATION:
            return { results: action.payload }
        default:
            return state;
    }
}